// The signed-in user's TRADING PRODUCTS (FUTURES_ONLY | OPTIONS_ONLY | BOTH), from the server
// (GET /options-access/me -> products). The UI hides what the account does not trade; the server
// refuses it regardless (trading_products.py), so this is presentation only.
import { useEffect, useState } from "react";
import api from "@/lib/api";

export const FUTURES = "FUTURES";
export const OPTIONS = "OPTIONS";

let cache = null;          // {mode, futures, options}
let inflight = null;
const listeners = new Set();

export function loadProducts(force = false) {
  if (cache && !force) return Promise.resolve(cache);
  if (!inflight) {
    inflight = api.get("/options-access/me")
      .then((r) => r.data?.products || { mode: null, futures: true, options: false })
      .catch(() => ({ mode: null, futures: true, options: false }))
      .then((p) => { cache = p; inflight = null; listeners.forEach((fn) => fn(p)); return p; });
  }
  return inflight;
}

export function resetProducts() { cache = null; inflight = null; }

/** {mode, futures, options, loaded}. Until loaded nothing product-specific is shown (no flash of the
 *  wrong product); an unreachable server falls back to futures only (loadProducts). */
export function useProducts() {
  const [p, setP] = useState(cache);
  useEffect(() => {
    listeners.add(setP);
    loadProducts().then(setP);
    const t = setInterval(() => { if (!document.hidden) loadProducts(true); }, 60000);
    return () => { listeners.delete(setP); clearInterval(t); };
  }, []);
  return { mode: p?.mode ?? null, futures: p ? !!p.futures : false, options: p ? !!p.options : false, loaded: !!p };
}

export function allows(products, product) {
  if (!product) return true;
  return product === FUTURES ? products.futures : products.options;
}
